module.exports = __webpack_public_path__ + "static/media/info.fe65d428.svg";